import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  Renderer2,
  SimpleChanges,
} from "@angular/core";
import {
  DataService,
  DeviceHelper,
  DialogLogoutComponent,
  FG_APP_CONSTANTS,
  FgAppConstants,
  FgMenuService,
  LocalStorageService,
  ThemingService,
  ToolbarComponent,
  TopNavComponent,
  UserService,
} from "fg-library";
import { takeUntil } from "rxjs/operators";
import {
  // Navigation
  MatMenuModule,
} from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";

import { allThemes } from "../allThemes";
import {
  fingressThemes,
  logout,
  Theme,
} from "../../toolbar/utils/toolbarUtils";

import {
  ActivatedRoute,
  NavigationExtras,
  NavigationStart,
  Router,
} from "@angular/router";
import { LayoutService } from "../../main-nav/layoutservice";
import { MatDialog } from "@angular/material/dialog";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
@Component({
    selector: "fg-client-rounded-top-nav",
    templateUrl: "./rounded-top-nav.component.html",
    styleUrls: ["./rounded-top-nav.component.scss"],
    standalone: false
})
export class FgClientRoundedTopNavComponent
  extends TopNavComponent
  implements OnChanges
{
  @Output() openSettingsRequested = new EventEmitter<void>();
  @Output() settingsClicked = new EventEmitter<void>();
  currentUserDetails: any;
  visibleItems = [];
  overflowItems = [];
  showMegaMenu = false;
  currentApp:string;
  currentPage:string;
  toggleMegaMenu() {
    this.showMegaMenu = !this.showMegaMenu;
  }
  triggerSettingsDrawer() {
    this.openSettingsRequested.emit(); // ✅ Matches the output
  }
  openSettingsDrawer() {
    this.settingsClicked.emit();
  }
  userRole: any = {};
  isMobile: boolean;
  hiddenMenu: boolean = false;
  themes: Theme[] = fingressThemes;

  currentTheme = this.themes[0].class;
  logo: string;
  showMe: boolean = false;

  constructor(
    public router: Router,
    public dataService: DataService,
    public route: ActivatedRoute,
    public fgMenuService: FgMenuService,
    @Inject(FG_APP_CONSTANTS) private fgAppConstant: FgAppConstants,
    // public fgUserService: UserService,
    public themingService: ThemingService,
    private renderer: Renderer2,
    private localStorage: LocalStorageService,
    private layoutService: LayoutService,
    public dialog: MatDialog,
    public userService: UserService,
    private translate: TranslateService
  ) {
    //super(router, dataService, route, fgMenuService);
    super(router, dataService, fgMenuService, route);
    this.isMobile = DeviceHelper.isMobile();
  }

  isDark = false;
  @Input() apps: any[];
  @Output() sidebarToggle = new EventEmitter<void>();
  ngOnInit(): void {
    this.apps = undefined;
    this.layoutService.layout$.subscribe((layout) => {
      this.setLayout(layout); // 👈 Apply layout update
    });

    let appPreference = JSON.parse(this.localStorage.get("AppPreference"));
    if (!appPreference)
      appPreference = {
        theme: "dark-theme",
        layout: "HORIZONTAL",
      };
    this.setLayout(appPreference.layout);

    //user details

    this.userService.currentUser.subscribe((response) => {
      this.currentUserDetails = response;
      if (this.currentUserDetails?.lastLoginTime)
        this.currentUserDetails["lastLoginTime"] = new Date(
          this.currentUserDetails["lastLoginTime"]
        );
    });

    if (this.fgMenuService.currentApplicationMenus) {
      this.menus = this.fgMenuService.currentApplicationMenus;
    }
    if (!this.apps || this.apps.length == 0) this.getApps();
    console.log("all apps :", this.apps);


  this.currentApp = this.getAppName();
  this.currentPage = this.getMenuName();

  }
  myapps: any;
  getMyApps() {
    this.myapps = this.apps
      .filter((app) => ["Web", "Universal"].includes(app.deviceChannel))
      .map((app) => {
        const allGroups = app.menuGroup || [];

        // 1. Separate actual groups vs leaf entries
        const actualGroups = allGroups.filter(
          (group) => group.menuGroup === true
        );
        const leafItems = allGroups.filter(
          (group) => group.menuGroup === false
        );

        // 2. Wrap leaf items under a synthetic group "Menus" with appId
        const newMenuGroups = [...actualGroups];

        if (leafItems.length > 0) {
          newMenuGroups.unshift({
            name: "Menus",
            menuGroup: true,
            menuItem: leafItems,
            appId: app.appId, // ✅ attach parent appId here
          });
        }

        return {
          ...app,
          menuGroup: newMenuGroups,
        };
      });

    return this.myapps;
  }

  logout(directLogin: boolean = false) {
    logout(
      directLogin,
      this.config,
      this.router,
      this.fgAppConstant,
      this.userService,
      this.dataService
    );
  }

  public openLogoutDialog(): void {
    const logoutDialog = this.dialog.open(DialogLogoutComponent, {
      width: "300px",
    });

    logoutDialog.afterClosed().subscribe((result) => {
      if (result) {
        this.logout();
      }
    });
  }

  goToLogin() {
    this.userService.logout();
    let session = this.userService.isUserLoggedIn();
    if (!session)
      this.router.navigate(["/app/login"], { queryParams: { logout: "true" } });
  }
  setLayout(layout: string) {
    if (layout == "VERTICAL") this.showMe = true;
    else {
      this.showMe = false;
      //  this.sidenav.close();
    }
  }
  toggleSidebar() {
    this.sidebarToggle.emit();
  }
  toggleDark(checked: boolean) {
    this.isDark = checked;
    const method = checked ? "addClass" : "removeClass";
    this.renderer[method](document.body, "dark-theme");
  }

  switch(themeClass: string) {
    // remove old
    this.themes.forEach((t) =>
      this.renderer.removeClass(document.body, t.class)
    );
    // apply new
    this.currentTheme = themeClass;
    this.renderer.addClass(document.body, themeClass);
    if ((themeClass = "dark-theme"))
      this.localConfig.currentLogo = "assets/img/logo_white.png";
    else this.localConfig.currentLogo = "assets/img/logo.png";
    this.localStorage.set("theme", this.currentTheme);
  }
  getCurrentLogo() {
    return this.currentTheme === "dark-theme"
      ? "assets/img/logo_white.png"
      : "assets/img/logo.png";
  }

  highlightCorporateAppOnServiceApp(appId: any) {
    if (
      this.fgMenuService.appId == "95d25831-1e24-46f4-bc99-3ebeff7a16be" &&
      appId == "ef45930c-cdd5-478e-80c1-f621736f393b"
    ) {
      return true;
    }
    return false;
  }

  isHiddenApp(appId) {
    var isHiddenApp = false;
    return isHiddenApp;
  }
  changeLanguage(lang: any) {
    this.dataService.getLocaleFile(lang).subscribe((response: any) => {
      this.translate.setDefaultLang(lang);
      this.translate.setTranslation(lang, response);

      const currentUrl = this.router.url;

      this.router.navigateByUrl("/", { skipLocationChange: true }).then(() => {
        // Navigate back to the current route
        this.router.navigate([currentUrl]);
      });
    });
  }

  isDataLoading = false;
  private destroyApps = new Subject();
  getApps() {
    this.isDataLoading = true;
    this.fgMenuService
      .getApps()
      .pipe(takeUntil(this.destroyApps))
      .subscribe((apps) => {
        if (apps.responseValue?.app) {
          this.apps = apps.responseValue.app;
          this.isDataLoading = false;
        } else {
          this.isDataLoading = false;
        }
      });
  }

  goToLandingPage() {
    let detailParams: NavigationExtras = {
      skipLocationChange: true,
    };

    var pageUrl =
      "page/" + this.config._customPageId + "/" + this.config._customAppId;
    this.router.navigateByUrl(`${pageUrl}`, {
      state: { id: detailParams },
      skipLocationChange: true,
    });
  }

  getAppName() {
    return this.getFirstLeafMenuName(this.fgMenuService.appId);
  }
  selectedAppName: string = ""; // Will hold the name of the selected app
  selectedMenuName: string = ""; // Will hold the name of the selected menu
  getFirstLeafMenuName(appId: string): string | null {
    const app = this.apps?.find((app) => app.appId === appId);
    if (!app || !Array.isArray(app.menuGroup)) return null;

    // Look for the first entry where menuGroup === false
    let pageData = undefined;

    if (
      this.route.snapshot.firstChild &&
      this.route.snapshot.firstChild.firstChild
    )
      return app.name;
  }

  getMenuNameByPageId(
    apps: any[],
    appId: string,
    pageId: string
  ): string | null {
    const app = apps?.find((app) => app.appId === appId);
    if (!app || !Array.isArray(app.menuGroup)) return null;

    for (const group of app.menuGroup) {
      const items = group.menuItem || [];
      const found = items.find((item) => item.pageId === pageId);
      if (found) return found.name;
    }

    return null; // not found
  }
  getMenuName(): string | null {
    let pageData = this.route.snapshot.firstChild.firstChild;
    let pageId = pageData?.params.pageId;
    let appId = pageData?.params.appId;
    const app = this.apps?.find((app) => app.appId === appId);
    if (!app || !Array.isArray(app.menuGroup)) return null;
    const found = app.menuGroup.find((item) => item.pageId === pageId);
    if(!found){
    for (const group of app.menuGroup) {
      const items = group.menuItem || [];
      const found = items.find((item) => item.pageId === pageId);
      if (found) return found.name;
    }
    }

    return found?.name;
  }
  onMenuItemSelected(event: { pageId: string; name: string }): void {

   
  this.currentPage = event.name;
 // console.log('Selected Page:', event.pageId, 'Name:', event.name);
  // You can also update state or perform navigation, etc.
}
}
